import { populateActions as populate } from '../utilities/constants';

const actions = [
  // FLAGS
  ...populate('FETCH_FLAGS'),
  ...populate('FETCH_FLAGS_CHECK'),

  ...populate('FETCH_INVITES'),
  ...populate('CREATE_INVITE'),

  ...populate('UPDATE_PERMISSIONS'),

  ...populate('CREATE_PROPERTY'),
  ...populate('FETCH_PROPERTY'),
  ...populate('UPDATE_PROPERTY'),
  ...populate('DELETE_PROPERTY'),

  ...populate('FETCH_PROPERTIES'),

  ...populate('FETCH_EVENTS'),

  ...populate('UPDATE_PURCHASER_PROPERTIES'),
  ...populate('UPDATE_PURCHASER_DETAILS'),
  ...populate('DEACTIVATE_PURCHASER'),
  ...populate('ACTIVATE_PURCHASER'),
  ...populate('ARCHIVE_PURCHASER'),
  ...populate('ARCHIVE_FEEDBACK'),
  ...populate('RESTORE_PURCHASER'),
  ...populate('STOP_CREDIT_PURCHASER'),
  ...populate('ALLOW_CREDIT_PURCHASER'),

  // CREDIT NOTES

  ...populate('FETCH_GLOBAL_CREDIT_NOTES'),
  ...populate('FETCH_CREDIT_NOTES'),

  // CONNECTION REQUESTS
  ...populate('UPDATE_CONNECTION'),
  ...populate('FETCH_CONNECTION'),

  // INVOICE
  ...populate('FETCH_INVOICE'),
  ...populate('REFUND_INVOICE'),
  ...populate('MARK_INVOICE_PAID'),
  ...populate('UPDATE_INVOICE_DATE'),
  ...populate('UPDATE_INVOICE_DUE_DATE'),
  ...populate('UPDATE_INVOICE_PROPERTIES'),
  ...populate('CHARGE_INVOICE'),

  // INVOICES

  ...populate('FETCH_INVOICES'),
  ...populate('BULK_UPDATE_INVOICE_DATES'),

  // ORDERS
  ...populate('UPDATE_ORDER'),
  ...populate('CREATE_ORDER'),
  ...populate('DELETE_ORDER'),
  ...populate('CREATE_PURCHASER_SCHEDULE_ORDER'),

  ...populate('FETCH_PURCHASER_SCHEDULES'),
  ...populate('SYNC_ORDER_INVOICE'),
  ...populate('CANCEL_ORDER'),
  ...populate('UPDATE_DELIVERY_DATE'),
  ...populate('UPDATE_ORDER_PROPERTIES'),

  // SUPPLIER
  ...populate('FETCH_SUPPLIER_USERS'),
  ...populate('FETCH_SUPPLIER_ACCOUNT_DETAILS'),

  ...populate('VERIFY_RETAILER_EMAIL'),

  ...populate('CANCEL_DELIVERY'),
  ...populate('RESTORE_DELIVERY'),

  ...populate('IMPORT_PRODUCTS'),
  ...populate('DELETE_PAYMENT_METHOD'),
  ...populate('CREATE_PAYMENT'),

  // Products
  ...populate('FETCH_MOST_ORDERED_PRODUCTS'),

  // SCHEDULES
  ...populate('SCHEDULE_RUN'),
  ...populate('SCHEDULE_CANCEL'),
  ...populate('SCHEDULE_REINSTATE'),

  // USERS
  ...populate('FETCH_USERS'),

  // Profile
  ...populate('CREATE_PROFILE'),
  ...populate('FETCH_PROFILES'),
  ...populate('FETCH_PROFILE'),
  ...populate('UPDATE_PROFILE'),
  ...populate('DELETE_PROFILE'),
  ...populate('BULK_APPLY_PROFILE'),

  // Promotions
  ...populate('CREATE_PROMOTION'),
  ...populate('UPDATE_PROMOTION'),
  ...populate('FETCH_PROMOTIONS'),
  ...populate('FETCH_PROMOTION'),
  ...populate('DELETE_PROMOTION'),
  ...populate('PAY_INVOICE'),
  ...populate('UPDATE_SUPPLIER_SERVICE_AREA_SAGA'),
  ...populate('DELETE_SUPPLIER_SERVICE_AREA_SAGA'),

  // these do not need the REQUEST/SUCCESS/ERROR suffix
  'SHOW_PROPERTY_DETAILS',
  'RESET_PROPERTY_DETAILS',
  'SET_PROPERTY_DETAILS',
  'POPULATE_FORM',
  'UPDATE_FORM',
  'CLEAR_FORM',
  'CLEAR_EVENTS',
  'CLEAR_PROFILE',
  'CLEAR_PROMOTION',
  // ORDERS
  'SET_FIELDS_CHANGED',
  // ORDER PROJECTIONS
  'UPDATE_ORDER_PROJECTIONS_STATE',
  'SET_ORDER_PROJECTIONS_LOADING',
  // VIDEO
  'REQUEST_HELP_VIDEO',
  'CLEAR_MOST_ORDERED_PRODUCTS',
] as const;

type EventName = (typeof actions)[number];

const events: { [K in EventName]: K } = Object.fromEntries(
  actions.map(event => [event, event])
) as { [K in EventName]: K };

export default events;
